var map = {
  "./pl.messages.tsx": [
    "22323",
    [
      6618
    ]
  ],
  "./cs.messages.tsx": [
    "30225",
    [
      7684
    ]
  ],
  "./en.messages.tsx": [
    "11472",
    [
      2779
    ]
  ],
  "./hu.messages.tsx": [
    "89768",
    [
      3547
    ]
  ],
  "./de.messages.tsx": [
    "64876",
    [
      4783
    ]
  ],
  "./it.messages.tsx": [
    "45170",
    [
      569
    ]
  ],
  "./sk.messages.tsx": [
    "30169",
    [
      204
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 5242;
module.exports = __rspack_async_context;
